import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  IAdminSettingsPaymentCountryGroupItemDeletePayload,
} from '../types';
import {
  SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_MUTATION_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_URL,

} from '../constants';

export default function useSettingsPaymentSystemsCountryGroupRemoveMutation(): IContextMutationResult<
  void,
  Error,
  IAdminSettingsPaymentCountryGroupItemDeletePayload
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    void,
    Error,
    IAdminSettingsPaymentCountryGroupItemDeletePayload
  >({
    mutationKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_MUTATION_KEY],
    mutationFn: (payload) => fetchDelete<void>(
      SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_URL,
      {
        urlParams: {
          id: payload.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
